import React from "react";
import { LoginForm, useAuth } from "../../components";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { Navigate, useLocation, useParams } from "react-router";
import {
  getPathToNavigate,
  LoginRouteState,
} from "../../helpers/navigationHelpers";
import { PrivateRouteParams } from "../invite/models";

const LoginPage: React.FC = (): React.ReactElement => {
  const { onLogin, authenticated, user } = useAuth();

  const originalLocation = useLocation().state as LoginRouteState | undefined;
  const params = useParams<PrivateRouteParams>();

  const { tCommon } = useCustomTranslation();

  if (authenticated && user) {
    return <Navigate to={getPathToNavigate(user, originalLocation?.from)} />;
  }

  return (
    <ContentWrapper small largePadding>
      <h1>{tCommon("customer_portal")}</h1>
      <p className="mb-6">{tCommon("customer_portal_description")}</p>
      <p className="mb-2 text-sm font-bold">{tCommon("login")}</p>
      <LoginForm
        onSubmit={async (values) =>
          await onLogin({
            ...values,
            customerId: originalLocation?.originalParams?.customerId,
            tenantCode: params.tenantCode,
          })
        }
      />
    </ContentWrapper>
  );
};

export default LoginPage;
